module.exports = __webpack_public_path__ + "static/media/sparkview.70b8f27c.png";